"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgChessKnight = function SvgChessKnight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M6.73.342c.407-.45.845-.34 1.143-.302.299.037 2.615.559 4.364 2.41 1.75 1.851 2.254 4.173 2.439 5.191.185 1.018.47 2.802-.068 6.285l-.008.076h.418s.982.038.982 1.005c0 .968-.984.993-.984.993H3.484s-.917.001-1-.986c0 0-.006-.921 1.02-1.007h.7l.359-1.365s.297-.808 1.239-.59c0 0 .734.208.678 1.066l-.202.889h6.307s.364-1.657.364-3.52c0-1.861-.314-4.206-1.648-6.068 0 0-1.087-1.481-2.77-2.098L6.89 3.891l.376.124s.964.32.65 1.318c0 0-.325.886-1.272.572-.948-.314-1.407-.46-1.407-.46L2 8.424s.101.415.583.359c.482-.057 2.226-.28 2.226-.28s.38-.051.577.072c.196.123.64.365 1.166.365.527 0 .959-.32.959-.32s.442-.252.885-.045c.443.208.897.87.331 1.593 0 0-.78.774-2.203.774 0 0-1.02-.05-1.721-.415l-2.001.236S1.71 10.98.796 10.15c-.914-.83-.79-1.94-.79-1.94s-.023-.68.672-1.302c.695-.622 5.909-5.506 5.909-5.506s-.265-.61.143-1.06z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

SvgChessKnight.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgChessKnight;
exports.default = _default;